import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges, OnDestroy } from '@angular/core';
import { AppMenu } from '../../models/app-menu';
import APP_MENU from '../../../../assets/menu/app-menu.json';
import { ProjectConfiguration } from '../../../features/project/models/project-configuration';
import { MenuService } from '../../services/menu.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { MenuBehaviorSubjectService } from '../../../shared/services/menu-behavior-subject.service';
import { StateService } from '@uirouter/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-menu',
  template: require('./menu.component.html'),
  styles: [require('./menu.component.sass')]
})
export class MenuComponent implements OnInit, OnDestroy {

  @Input() activePages: String[];
  @Input() projectConfiguration: ProjectConfiguration;
  @Input() isAdmin: boolean;
  @Input() activeProjectConfigurations: ProjectConfiguration[];
  @Output() click = new EventEmitter<AppMenu>();

  projectId: number;
  appMenu: AppMenu[];
  languageChangeSubscription: Subscription;
  menuChangeSubscription: Subscription;
  selectedProjectIds: string;

  constructor(
    private menuService: MenuService,
    private translateService: TranslateService,
    private menuBehaviorSubjectService: MenuBehaviorSubjectService, 
    private stateService: StateService,
    private cookieService: CookieService
  ) { 
    this.languageChangeSubscription = this.translateService.onLangChange.subscribe(({lang} : {lang: string}) => {
      this.generateMenu(lang);
    })

    this.menuChangeSubscription = this.menuBehaviorSubjectService.changeOccured.subscribe((data) => {
      if (data) {
        switch (data.action) {
          case 'project-menu-changed':
            this.selectedProjectIds = data.parameter;
            this.generateMenu();
          break;
        }
      }
    })
  }

  ngOnInit(): void {
    this.selectedProjectIds = this.cookieService.get('nomad.noc.ng.projects');
    this.generateMenu();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.generateMenu();
  }

  generateMenu = (lang?: string) => {
    this.projectId = this.stateService.params && this.stateService.params.projectId;
    const unusedPages = this.projectConfiguration && this.projectConfiguration.frontendMenu && this.projectConfiguration.frontendMenu.unusedPages;
    let allAppMenu: AppMenu[] = APP_MENU.menu;
    allAppMenu = this.menuService.addAlarmsMenu(this.projectId, allAppMenu, this.activeProjectConfigurations, (lang || this.translateService.currentLang), this.selectedProjectIds);
    if (unusedPages && unusedPages.length > 0) {
      this.disableUnusedPages(allAppMenu, unusedPages);
    }

    if (this.isAdmin) {
      this.appMenu = [...allAppMenu];
    } else {
      this.setMenuVisibility(allAppMenu, this.activePages);
      this.appMenu = allAppMenu
    }
    this.disableParentWithoutChildSubMenu(this.appMenu)
    this.menuBehaviorSubjectService.inform("MENU_CREATED", '');
  }

  onMenuClick = (item: AppMenu) => {
    this.click.emit(item);
  }

  disableUnusedPages = (menuItems: AppMenu[], unusedPages: String[]) => {
    return menuItems.forEach(subMenu => {
      subMenu.visible = true;
      if (subMenu.items && subMenu.items.length > 0) {
        return this.disableUnusedPages(subMenu.items, unusedPages)
      } else {
        subMenu.visible = !unusedPages.find(page => page === subMenu.page);
      }
    }) 
  }

  setMenuVisibility = (menuItems: AppMenu[], activePages: String[]) => {
    return menuItems.forEach(subMenu => {
      subMenu.visible = false;
      if (subMenu.items && subMenu.items.length > 0) {
        return this.setMenuVisibility(subMenu.items, activePages)
      } else {
        subMenu.visible = !!activePages.find(page => page === subMenu.page);
      }
    }) 
  }

  disableParentWithoutChildSubMenu = (menuItems: AppMenu[], parent?: AppMenu, greatParent?: AppMenu) => {
    if (greatParent) {
      greatParent.visible = !! (greatParent.items && greatParent.items.reduce((acc: boolean, item) => acc || item.visible, false))
    }
    return menuItems.forEach(subMenu => {
      if (subMenu.items && subMenu.items.length > 0) {
        subMenu.visible = subMenu.items.reduce((acc: boolean, item) => acc || item.visible, false)
        if (parent) {
          parent.visible = parent.visible || subMenu.items.reduce((acc: boolean, item) => acc || item.visible, false)
        }
        return this.disableParentWithoutChildSubMenu(subMenu.items, subMenu, parent);
      } else {
        
      }
    }) 
  }

  ngOnDestroy(): void {
      this.languageChangeSubscription.unsubscribe();
      this.menuChangeSubscription.unsubscribe();
  }

}
